import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  AMENITIES_ADD_PATH,
  AMENITIES_PATH,
  AMENITIES_UPDATE_PATH,
} from "utils/constants/paths";

const Amenities = Loadable(React.lazy(() => import("./View")));
const AmenitiesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const AmenitiesRoute: IRouteItem = {
  path: AMENITIES_PATH,
  iconName: "Bubble",
  element: React.createElement(Amenities),
  name: "Amenities",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: AMENITIES_ADD_PATH,
      element: React.createElement(AmenitiesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: AMENITIES_UPDATE_PATH,
      element: React.createElement(AmenitiesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
